import React from 'react'
import { Spacer, Text, Flex } from '@chakra-ui/react'
import { GoosfrabaLogotype } from '../../assets'

const Watermark = () => (
  <>
    <Spacer />
    <Flex
      justify="flex-end"
      align="center"
      borderTop="1px"
      borderColor="gray.200"
      pt="1"
      mt="4"
      p={{ base: '2', md: '4' }}
    >
      <Text textColor="gray.400" mr="1">
        Powered by
      </Text>
      <GoosfrabaLogotype style={{ height: '1.2rem' }} />
    </Flex>
  </>
)

export default Watermark
